export const MAX_COLS = 24;
export const INDEX_PROP = "index";
